import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/button';

const LocationSection = () => {
  const openGoogleMaps = () => {
    window.open('https://www.google.com/maps/search/Nakasero+Hill+Concord+Apartments+Kampala+Uganda', '_blank');
  };

  const nearbyPlaces = [
    { name: 'Kampala City Center', distance: '2 km' },
    { name: 'Entebbe International Airport', distance: '35 km' },
    { name: 'Kololo Airstrip', distance: '3 km' },
    { name: 'Mulago Hospital', distance: '4 km' },
    { name: 'Garden City Mall', distance: '5 km' },
    { name: 'Uganda Golf Club', distance: '2 km' }
  ];

  return (
    <section id="location" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-amber-600 font-medium tracking-wider uppercase text-sm">
            Prime Location
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-slate-900 font-semibold mt-4 mb-6">
            Nakasero Hill, Kampala
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Situated in one of Kampala&apos;s most prestigious neighborhoods, 
            Concord Apartments offers unparalleled access to the city&apos;s 
            finest attractions and essential services.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map Placeholder */}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <div className="aspect-[4/3] bg-slate-200 relative">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15959.253779123456!2d32.5730!3d0.3163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbd8f8b8b8b8b%3A0x8b8b8b8b8b8b8b8b!2sNakasero%2C%20Kampala%2C%20Uganda!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Concord Apartments Location"
                className="absolute inset-0"
              />
            </div>
            <div className="absolute bottom-4 left-4 right-4">
              <Button
                onClick={openGoogleMaps}
                className="w-full bg-white hover:bg-slate-50 text-slate-900 shadow-lg rounded-xl py-4"
              >
                <Navigation className="w-4 h-4 mr-2" />
                Get Directions
              </Button>
            </div>
          </div>

          {/* Location Details */}
          <div>
            <div className="flex items-start gap-4 mb-8">
              <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <MapPin className="w-6 h-6 text-amber-600" />
              </div>
              <div>
                <h3 className="font-serif text-2xl text-slate-900 font-semibold mb-2">
                  Concord Apartments
                </h3>
                <p className="text-slate-600">
                  Nakasero Hill, Kampala, Uganda
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-100">
              <h4 className="font-semibold text-slate-900 mb-4">Nearby Landmarks</h4>
              <div className="space-y-4">
                {nearbyPlaces.map((place, idx) => (
                  <div key={idx} className="flex items-center justify-between py-2 border-b border-slate-100 last:border-0">
                    <span className="text-slate-600">{place.name}</span>
                    <span className="text-amber-600 font-medium">{place.distance}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="bg-amber-50 rounded-2xl p-5 text-center">
                <p className="text-3xl font-serif text-amber-600 font-semibold">24/7</p>
                <p className="text-slate-600 text-sm mt-1">Security</p>
              </div>
              <div className="bg-amber-50 rounded-2xl p-5 text-center">
                <p className="text-3xl font-serif text-amber-600 font-semibold">5 min</p>
                <p className="text-slate-600 text-sm mt-1">To CBD</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
